import * as React from "react";
import { invoiceStatusTone } from "../../../lib/invoiceStatus.utils";
import { StatusPill, StatusPillOutline, StatusPillStyle } from "../../StatusPill";

/** An invoice's status in its tone's colours, like the job page's pill. */
export const InvoiceStatusPill: React.FC<{
  status?: string | null;
  variant?: StatusPillStyle;
  outline?: StatusPillOutline;
  className?: string;
}> = ({ status, variant, outline, className }) => (
  <StatusPill
    label={status || "No status"}
    ariaLabel={`Invoice status: ${status || "none"}`}
    tone={invoiceStatusTone(status)}
    variant={variant}
    outline={outline}
    className={className}
  />
);
